import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Andrea Müller',
  school: 'Kantonsschule Zürich',
  city: 'Zürich'
}, {
  name: 'Thomas Weber',
  school: 'Gymnasium Bern',
  city: 'Bern'
}, {
  name: 'Nicole Schneider',
  school: 'Wirtschaftsmittelschule Basel',
  city: 'Basel'
}, {
  name: 'Stefan Brunner',
  school: 'Kantonsschule Luzern',
  city: 'Luzern'
}, {
  name: 'Petra Keller',
  school: 'Gymnasium Kirchenfeld',
  city: 'Bern'
}, {
  name: 'Daniel Frei',
  school: 'Kantonsschule Winterthur',
  city: 'Winterthur'
}, {
  name: 'Michael Steiner',
  school: 'Kantonsschule St. Gallen',
  city: 'St. Gallen'
}, {
  name: 'Claudia Aebi',
  school: 'Gymnasium Köniz',
  city: 'Köniz'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-168">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: 50,
      y: -20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: 50,
      scale: 0.9
    }} className="fixed top-4 right-4 sm:top-8 sm:right-8 z-50 max-w-[300px] w-full" data-id="element-169">
          <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-lg relative overflow-hidden" data-id="element-170">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-171">
              <XIcon className="w-4 h-4" data-id="element-172" />
            </button>

            <div className="flex items-start gap-3" data-id="element-173">
              <div className="w-10 h-10 rounded-full bg-swiss-blue-expert flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-174">
                {currentBuyer.name.charAt(0)}
              </div>
              <div className="pr-4" data-id="element-175">
                <p className="text-xs sm:text-sm text-gray-700 leading-tight" data-id="element-176">
                  <span className="font-bold text-swiss-charcoal" data-id="element-177">
                    {currentBuyer.name}
                  </span>{' '}
                  aus {currentBuyer.city} hat soeben das W&R Master-System 2026
                  gekauft
                </p>
                <div className="flex items-center gap-2 mt-1.5" data-id="element-178">
                  <span className="flex items-center gap-1 text-[10px] sm:text-xs text-swiss-green-cta font-bold" data-id="element-179">
                    <span className="w-1.5 h-1.5 rounded-full bg-swiss-green-cta animate-pulse" data-id="element-180" />
                    Verifiziert
                  </span>
                  <span className="text-[10px] sm:text-xs text-gray-500" data-id="element-181">
                    · vor {timeAgo} Minuten
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}